"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Button } from "@/components";
import { useSwiperSliderOptions, getImageURL } from "@/lib";

export const HomePageBanner = ({ data = {}, slug = "home-banner" }) => {
    const bannerSlides = data?.banner_slider || [];

    const { options } = useSwiperSliderOptions({
        slidesPerView: 1,
        modules: [Autoplay, Pagination],
        loop: bannerSlides.length > 1,
        speed: 1000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".banner-pagination",
            clickable: true,
        },
    });

    return (
        <>
            <section className="home__banner__usa" id={slug}>
                <div className="banner__rtl_wrapper">
                    <div className="banner__rtl_slider">
                        <Swiper {...options}>
                            {bannerSlides.map((slide, index) => {
                                const {
                                    banner_video = {},
                                    banner_image = {},
                                    cta = {},
                                    description = "",
                                    title = "",
                                    banner_scroll_text = "",
                                    link = {},
                                } = slide;

                                const videoSrc = getImageURL(
                                    banner_video?.src || "",
                                );
                                const imageSrc = getImageURL(banner_image?.src);
                                const imageAlt = banner_image?.alt || "";

                                const ctaButton =
                                    cta &&
                                    cta.title &&
                                    (cta.url || cta.external_url) ? (
                                        <Button
                                            label={cta.title}
                                            href={
                                                cta.url_type === "external"
                                                    ? cta.external_url
                                                    : cta.url
                                            }
                                            target={
                                                cta.open_new_tab === "yes"
                                                    ? "_blank"
                                                    : undefined
                                            }
                                        />
                                    ) : null;

                                const scrollText = banner_scroll_text || "";
                                const scrollLink =
                                    link?.url ||
                                    link?.url_1 ||
                                    (link?.url_type === "external"
                                        ? link?.external_url
                                        : undefined) ||
                                    "#";
                                const scrollLinkTarget =
                                    link?.open_new_tab === "yes"
                                        ? "_blank"
                                        : undefined;
                                const scrollLinkRel =
                                    link?.open_new_tab === "yes"
                                        ? "noopener noreferrer"
                                        : undefined;

                                return (
                                    <SwiperSlide key={index}>
                                        <div className="item__wrap">
                                            <div className="img__wrap">
                                                {videoSrc ? (
                                                    <video
                                                        id={`video-main-${index}`}
                                                        autoPlay
                                                        playsInline
                                                        loop
                                                        muted
                                                        poster={imageSrc || ""}
                                                        width="100%"
                                                    >
                                                        <source
                                                            src={videoSrc}
                                                            type="video/mp4"
                                                        />
                                                    </video>
                                                ) : imageSrc ? (
                                                    <img
                                                        className="img-fluid bg_img"
                                                        src={imageSrc}
                                                        alt={imageAlt}
                                                    />
                                                ) : null}
                                            </div>
                                            <div className="single__item">
                                                <div className="custom-container">
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-10 col-lg-7">
                                                            <div className="banner__area">
                                                                <div className="banner__content text-white text-center">
                                                                    <h1
                                                                        className="h1 fs-72 fw-600 text-white"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: title,
                                                                        }}
                                                                    />
                                                                    {ctaButton}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="scroll_bottom_icon fs-14">
                                                {scrollText ? (
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: scrollText,
                                                        }}
                                                    />
                                                ) : null}
                                                <div className="container_mouse">
                                                    <a
                                                        href={scrollLink}
                                                        onClick={(e) => {
                                                            if (
                                                                scrollLink?.startsWith(
                                                                    "#",
                                                                ) &&
                                                                link?.open_new_tab !==
                                                                    "yes"
                                                            ) {
                                                                e.preventDefault();
                                                                const targetElement =
                                                                    document.getElementById(
                                                                        scrollLink.slice(
                                                                            1,
                                                                        ),
                                                                    );
                                                                if (
                                                                    targetElement
                                                                ) {
                                                                    const y =
                                                                        targetElement.getBoundingClientRect()
                                                                            .top +
                                                                        window.pageYOffset -
                                                                        80;
                                                                    window.scrollTo(
                                                                        {
                                                                            top: y,
                                                                            behavior:
                                                                                "smooth",
                                                                        },
                                                                    );
                                                                }
                                                            }
                                                        }}
                                                        target={
                                                            scrollLinkTarget
                                                        }
                                                        rel={scrollLinkRel}
                                                        aria-label="Scroll to next section"
                                                    >
                                                        <span className="mouse-btn">
                                                            <span className="mouse-scroll" />
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                        <div className="banner-pagination" />
                    </div>
                </div>
            </section>
        </>
    );
};
